// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhy_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhy_sw bhy_sv"};